/**
 * @fileoverview POST handler for the "/engagement/audience_sync/:platform/ad_accounts/:ad_account_id/audiences" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAudienceSyncPlatformAdAccountsAdAccountIdAudiencesCacheKeys } from "./constants";
import type {
  PostEngagementAudienceSyncPlatformAdAccountsAdAccountIdAudiencesProps,
  EngagementAudienceSyncPlatformAdAccountsAdAccountIdAudiencesResult,
} from "./types";

export const postEngagementAudienceSyncPlatformAdAccountsAdAccountIdAudiences = reactQueryMutationAdapter(
  engagementAudienceSyncPlatformAdAccountsAdAccountIdAudiencesCacheKeys,
  ({
    platform,
    adAccountId,
    audienceName,
    fields,
    region,
  }: PostEngagementAudienceSyncPlatformAdAccountsAdAccountIdAudiencesProps): Promise<EngagementAudienceSyncPlatformAdAccountsAdAccountIdAudiencesResult> => {
    return fetch(
      `/engagement/audience_sync/${platform}/ad_accounts/${encodeURIComponent(adAccountId)}/audiences`,
      "POST",
      { audience_name: audienceName, fields, ...(region ? { region } : {}) },
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
